import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type Recommendation } from '../../api/decision';

export function RecommendationCenterPage() {
  const [recs, setRecs] = useState<Recommendation[]>([]);

  useEffect(() => {
    void decisionApi.listRecommendations((getWorkspaceId() ?? '')).then(setRecs);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Recommendation Center</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">AI-generated recommendations across pricing, inventory, advertising and operations.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      <div className="mt-6 space-y-3">
        {recs.map((r) => (
          <div key={r.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium">{r.title}</p>
                <p className="text-xs text-slate-500">{r.domain} · {r.priority}</p>
              </div>
              <span className="text-sm text-indigo-600">{(r.confidence * 100).toFixed(0)}% conf</span>
            </div>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{r.description}</p>
            {r.explanation && <p className="mt-1 text-xs text-slate-500">{r.explanation}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
